import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const wellnessCheckImporterSelectors = importerSelectors(
  'wellnessCheck.importer',
);

export default wellnessCheckImporterSelectors;
